import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const ToastBox = styled.div`
  position: fixed;
  top: 15%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 10000;

  display: flex;
  align-items: center;
  gap: 10px;

  width: fit-content;
  max-width: min(90%, 520px);
  padding: 14px 22px;

  background: linear-gradient(135deg, #232323 0%, #131313 100%);
  border: 1px solid #f2fa18;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.5);

  animation: grandToastIn 0.25s ease-out;
  @keyframes grandToastIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ToastIcon = styled.span`
  flex-shrink: 0;
  font-size: 18px;
  line-height: 1;
  color: #f2fa18;
`;

const ToastText = styled.p`
  margin: 0;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  word-break: keep-all;
`;

const useToast = () => {
  const navigate = useNavigate();
  const [toastOpen, setToastOpen] = useState(false);

  const openToast = (page) => {
    setToastOpen(true);

    setTimeout(() => {
      setToastOpen(false);
      if (page) {
        navigate(page)
      }
    }, 5000);
  };

  const Toast = ({ Icon, toastText }) =>
    toastOpen && (
      <ToastBox>
        <ToastIcon>{Icon || "⚠"}</ToastIcon>
        <ToastText>{toastText}</ToastText>
      </ToastBox>
    );

  return {
    Toast,
    toastOpen,
    openToast,
  };
};

export default useToast;
